import React from 'react'
import {HiArrowNarrowRight} from 'react-icons/hi'
function Home() {
  

  
  return (
    <div name="home" className="w-full h-screen bg-[#0a192f]">
{/** container */}

<div className='max-w-[1100px] mx-auto  px-8 flex flex-col justify-center h-full'>
<p className='text-pink-600 text-4xl font-bold py-2 '>
Hello,my name is </p>
<h1 className='text-4xl sm:text-7xl font-bold text-[#ccd6f6] py-2'>
Vivek Kumar
</h1>

<h2 className='text-4xl sm:text-7xl font-bold text-[#8892b0] py-2' >
I'm a Full Stack Web Developer</h2>

<p className='text-[#8892b0] py-4 max-w-[700px] text-xl'>
A persistent learner and MERN Stack

developer with proficiency in pixel-
perfect design and implementing

end-to-end functionality. Passionate
about new technologies and aspiring
to join a team to learn and grow in a
collaborative environment.
</p>
<div>

<a href="https://drive.google.com/drive/folders/1DI8IhXNTdyg34d6Pj6PIF3eu7bF6JC_s?usp=sharing" target="_blank"  rel="noreferrer">
<button 
className='text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-pink-600'>

Resume

<span className='group-hover:rotate-90 duration-300'>

<HiArrowNarrowRight className='ml-3'/>
</span></button>

</a>

</div>
</div>


    </div>

  )
}

export default Home